import { handleActions } from "redux-actions";
import _get from "lodash/get";
import _assign from "lodash/assign";
import addHours from "date-fns/add_hours";
//
import { _addIf, cloneDate } from "../../utils";
import { getMinDate, getMaxDate } from "../../utils/booking";
import { MODEL_SHOW, MODEL_PREBOOK, ACCEPT_TIME } from "../models/actions";
import { INTL_CITY_SET } from "../intl";
import { MODAL_HIDE } from "../modal/actionTypes";
import { USER_GET } from "../auth/actionTypes";
import { AJAX_ERROR, AJAX_SUCCESS } from "../ajax";
import {
  BOOKING_TIME_SET,
  BOOKING_DURATION_SET,
  BOOKING_DURATION_CHANGE,
  BOOKING_GENDER_SET,
  BOOKING_INPUT_SET,
  BOOKING_SERVICE_SET,
  BOOKING_CREATE,
  BOOKING_PHONE_UPDATE,
  BOOKING_ERRORS,
  BOOKING_OUTCALL_SET,
  BOOKING_CALLME,
  BOOKING_OTPTYPE_SET,
} from "./actions";

// Reducer
const serverState = window.initialState;

const cityId = _get(serverState, "intl.cityId");

let isBangkok = !cityId || cityId === 1;
let isComplimentaryCity = !isBangkok;
let isManila = cityId === 3;

const minDate = getMinDate(isManila);

const initialState = _assign(
  {
    isFetching: false,
    newDate: null,
    minDate,
    maxDate: getMaxDate(minDate),
    date: cloneDate(minDate),
    duration: isComplimentaryCity ? 60 : 120,
    outcall: true,
    fullname: "",
    email: "",
    message: "",
    roomNumber: "",
    services: [],
    errors: [],
    genderId: 1,
    phone: "",
    otpType: null,
    id: null,
    verified: null,
    contact_provider: "phone",
    contact_provider_id: "",
  },
  serverState.booking
);

const { debug } = window.SERVER;

if (debug) {
  initialState.fullname = "Plaa Boon";
  initialState.email = "plaa.boon@mail.ru";
  initialState.message = "TEST TEST TEST TEST.";
  initialState.roomNumber = "TEST";
}

export default handleActions(
  {
    [BOOKING_TIME_SET]: applySetTime,
    [BOOKING_DURATION_SET]: applySetDuration,
    [BOOKING_INPUT_SET]: applySetInput,
    [BOOKING_SERVICE_SET]: applySetService,
    [MODEL_SHOW]: applySetModel,
    [MODEL_PREBOOK.FULFILLED]: applySetModel,
    [BOOKING_ERRORS]: applyBookingErrors,
    [BOOKING_CREATE.PENDING]: applyCreateBookingPending,
    [BOOKING_CREATE.FULFILLED]: applyCreateBookingFullfilled,
    [AJAX_ERROR]: applyAjaxError,
    [MODAL_HIDE]: applyHideModal,
    [BOOKING_GENDER_SET]: applySetGender,
    [BOOKING_PHONE_UPDATE.FULFILLED]: applyUpdatePhoneFullfilled,
    [USER_GET.FULFILLED]: applySetUser,
    [INTL_CITY_SET]: applyCity,
    [BOOKING_OUTCALL_SET]: applyOutcall,
    [BOOKING_OTPTYPE_SET]: applyOtpType,
    [BOOKING_CALLME.PENDING]: applyCallmePending,
    [BOOKING_DURATION_CHANGE]: applyChangeDuration,
    [ACCEPT_TIME]: applyAcceptTime,
    [AJAX_SUCCESS]: applyAjaxSuccess,
  },
  initialState
);

// Controllers
function applySetTime(state, action) {
  return {
    ...state,
    date: action.payload,
  };
}

function applySetDuration(state, action) {
  return {
    ...state,
    duration: action.payload,
  };
}

function applySetInput(state, action) {
  const { name, value } = action.payload;

  return {
    ...state,
    [name]: value,
  };
}

function applySetService(state, action) {
  const { services: oldServices } = state;

  return {
    ...state,
    services: _addIf(oldServices, action.payload),
  };
}

function applySetModel(state, action) {
  return {
    ...state,
    services: [],
  };
}

function applyBookingErrors(state, action) {
  return {
    ...state,
    errors: action.payload,
  };
}

function applyHideModal(state, action) {
  return {
    ...state,
    genderId: initialState.genderId,
  };
}

function applySetGender(state, action) {
  return {
    ...state,
    genderId: action.payload,
  };
}

function applyCreateBookingPending(state) {
  return {
    ...state,
    isFetching: true,
  };
}

function applyCreateBookingFullfilled(state, action) {
  const { id, verified } = action.payload;

  return {
    ...state,
    id,
    verified,
    isFetching: false,
  };
}

function applyAjaxError(state, action) {
  const { error } = action.payload;
  const isTimeError =
    typeof error === "string" && error.indexOf("booking_time_invalid") === 0;

  if (isTimeError) {
    if (error === "booking_time_invalid") {
      const { date, minDate, maxDate } = resetDates(isManila);

      return {
        ...state,
        date,
        minDate,
        maxDate,
        isFetching: false,
      };
    }

    // booking_time_invalid_multi
    // Suggest new date 2h in advance because of distance between cities (multi)
    const newDate = addHours(getMinDate(), 1);

    return {
      ...state,
      newDate,
      isFetching: false,
    };
  }

  return {
    ...state,
    isFetching: false,
  };
}

function applyUpdatePhoneFullfilled(state, action) {
  const { phone } = action.payload;

  return {
    ...state,
    phone,
  };
}

function applySetUser(state, action) {
  const { name, email } = action.payload;

  return {
    ...state,
    fullname: name,
    email: email,
  };
}

function applyOutcall(state, action) {
  return {
    ...state,
    duration: action.payload ? (isComplimentaryCity ? 60 : 120) : 15,
    outcall: action.payload,
  };
}

function applyOtpType(state, action) {
  return {
    ...state,
    otpType: action.payload,
  };
}

function applyCallmePending(state, action) {
  return {
    ...state,
    otpType: "call",
  };
}

function applyCity(state, action) {
  const { cityId } = action.payload;

  isBangkok = cityId === 1;
  isManila = cityId === 3;
  isComplimentaryCity = !isBangkok;

  const { date, minDate, maxDate } = resetDates(isManila);

  return {
    ...initialState,
    duration: isComplimentaryCity ? 60 : 120,
    date,
    minDate,
    maxDate,
  };
}

function applyChangeDuration(state, action) {
  const { duration, outcall } = action.payload;

  return {
    ...state,
    duration,
    outcall,
  };
}

function applyAcceptTime(state) {
  const { newDate } = state;

  if (newDate) {
    return {
      ...state,
      date: cloneDate(newDate),
      newDate: null,
    };
  }

  return state;
}

function applyAjaxSuccess(state) {
  return {
    ...state,
    isFetching: false,
  };
}

// Local helpers
function resetDates(isLong = false) {
  const minDate = getMinDate(isLong);

  return {
    date: cloneDate(minDate),
    minDate,
    maxDate: getMaxDate(minDate),
  };
}
